document.addEventListener("DOMContentLoaded", () => {
  // for hide the explore-button on best-coffee-by-page
  hideFirstDeliveryVariants();

  // --- Run initially ---
  handleDeliveryOptions();
  addAdditionalTextForSizeVariant();
  hideSellingPlanOption([],true);

  // --- Re-run whenever Appstle re-injects DOM ---
  const observer = new MutationObserver(() => {
    hideFirstDeliveryVariants();
    addAdditionalTextForSizeVariant();
    hideSellingPlanOption([],true);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


function addAdditionalTextForSizeVariant(){
  // Find the legend with text "Size"
  const legends = document.querySelectorAll('legend.form__label');

  const sizeLegend = Array.from(legends).find(
    el => el.textContent.trim() === 'Size'
  );

  if (sizeLegend) {
    let span = sizeLegend.querySelector('span');

    // If span already exists, update it
    if (span) {
      span.textContent = '(Size applies to full-size deliveries. Explorer boxes use tasting sizes*)';
    } else {
      // Otherwise, create and append one
      span = document.createElement('span');
      span.textContent = '(Size applies to full-size deliveries. Explorer boxes use tasting sizes*)';
      span.style.marginLeft = '6px';

      sizeLegend.appendChild(span);
    }

    span.style.setProperty('font-size', '16px', 'important');
    span.style.setProperty('font-weight', '400', 'important');
    span.style.setProperty('line-height', 'var(--body-tag-line-height)', 'important');
    span.style.setProperty('letter-spacing', 'normal', 'important');
    span.style.setProperty('font-family','var(--body-tag-font-family)','important');
  }
};


/**
 * function to hide the "first delivery variants"
 */
function hideFirstDeliveryVariants(){

  document.querySelectorAll("fieldset.product-form__input")?.forEach(fieldset => {
    const legend = fieldset.querySelector("legend.form__label");
    if (legend && legend.textContent.trim() === "First Delivery") {
      fieldset.style.display = "none";
    }
  });
};



// --- Helpers ---
function selectKit() {
  const kitRadio = document.querySelector(
    'input[name^="First Delivery"][value="Kit"]'
  );
  if (kitRadio) {
    kitRadio.checked = true;
    kitRadio.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function selectWithoutKit() {
  const withoutKitRadio = document.querySelector(
    'input[name^="First Delivery"][value="Coffee"]'
  );//[Without Kit]
  if (withoutKitRadio) {
    withoutKitRadio.checked = true;
    withoutKitRadio.dispatchEvent(new Event("change", { bubbles: true }));
  }
}


// formate options-value 

function formateAllOptionsValue(allOptions={}){
  const formattedAllOptions = Object.entries(allOptions).reduce((acc, [groupName, groupData]) => {
    if (!groupData) return acc;

    acc[groupName] = {
      tastes: groupData.tastes?.map(({ taste }) => ({ taste })) ?? [],
      currentIndex: groupData.currentIndex ?? "0", // default "0" if missing
    };

    return acc;
  }, {});

  return formattedAllOptions;
}






function handleDeliveryOptions() {
  const defautlSelectedPrefValue = {};

  const optionsList = document.getElementById("delivery-options-container");
  
  // inpu fields 
  const prefType = document.getElementById("preferenceType");
  const selectedPrefs = document.getElementById("selectedTaste");
  const customTaste = document.getElementById("customTaste");
  const groupName = document.getElementById("groupName");
  const selectionType = document.getElementById("selectionType");
  
  // manual options container div
  const manualOptionsWrapper = document.getElementById(
    "manual-subscription-options"
  );

  if (!optionsList) return;

  // Initialize with Explorer Box selected by default
  const firstOption = optionsList.children[0];
  firstOption.classList.add("active");
  prefType.value = "explorer_kit";
  selectKit();


  // Set all options as selected by default (for explorer kit)
  const allOptions = JSON.parse(optionsList.dataset.options);
  // const groupList = JSON.parse(optionsList.dataset.group);


  const grpName = Object.keys(allOptions).find((key)=>allOptions[key]?.tastes?.length);

  const formattedAllOptions = formateAllOptionsValue(allOptions);


  selectedPrefs.value = JSON.stringify(formattedAllOptions);
  // customTaste.value = JSON.stringify([""]);
  groupName.value = grpName;
  selectionType.value = "false"

  Array.from(optionsList.children).forEach((item) => {
    item.addEventListener("click", () => {
      
      if (item.classList.contains("active")) {
        return;
      }

      // Update active option
      Array.from(optionsList.children).forEach((option) => {
        option.classList.remove("active");
      });
      item.classList.add("active");

      if (item.dataset.selection?.toLowerCase() === "auto") {
        // Explorer Box - select all options automatically
        selectionType.value = "false";
        prefType.value = "explorer_kit";
        selectedPrefs.value = JSON.stringify(formateAllOptionsValue(allOptions));
        manualOptionsWrapper.classList.add("hidden");
        manualOptionsWrapper.innerHTML = "";
        groupName.value = Object.keys(allOptions).find((key)=>allOptions[key]?.tastes?.length);

        /**
         * this part is for explorer kit, we clicking the "kit" variant from here if user click on "explorer box"
         */
        selectKit();

      } else if(item.dataset.selection?.toLowerCase() === "manual") {
        // Custom Selection - show options for manual selection
        selectionType.value = "false";
        prefType.value = "skip_explorer_kit";

        /**
         * by default in skip-kit keep all the group but with empty tastes field ([]), once user pick manually then online selected group will have taste value in the tastes field else empty 
         */
        const allOptionsWithEmptyTaste = Object.assign({},allOptions);
        
        Object.keys(allOptionsWithEmptyTaste).map((groupName)=>{

          allOptionsWithEmptyTaste[groupName] = {
            ...allOptionsWithEmptyTaste[groupName],
            tastes:[]
          };
        });

        selectedPrefs.value = JSON.stringify(formateAllOptionsValue(allOptionsWithEmptyTaste)); // Start with default selection value but with empty taste field

        /**
         * select the first group which have at-least a value into tastes field, if all the group have empty taste field then select the first groupName as default groupName
         */
        const defaultGroupName = Object.keys(allOptionsWithEmptyTaste).find((key)=>allOptionsWithEmptyTaste[key]?.tastes?.length) || Object.keys(allOptionsWithEmptyTaste)[0];
        groupName.value = defaultGroupName

        manualOptionsWrapper.classList.remove("hidden");
        populateManualOptions(allOptions,manualOptionsWrapper);


        /**
         * this part is for skip-explorer kit, we clicking "without kit" variant from here if use click on "skip-explorer-kit"
         */
        selectWithoutKit();
      }
    });
  });
};


function populateManualOptions(options,manualOptionsWrapper) {
  Object.keys(options).forEach((groupName)=>{
    const manualOptionChildWrapper = document.createElement("div");
    manualOptionChildWrapper.id = `manual-subscription-options-${groupName}`;
    manualOptionChildWrapper.className = "manual-options-wrapper";
    // creating title 
    const titleEle = document.createElement("h4");
    titleEle.className = "manual-options-title";
    titleEle.textContent = `Pick ${groupName.split("-").join(" ")} profile:`
    // appending child to manualOptionChildWrapper
    manualOptionChildWrapper.appendChild(titleEle)

    // creating grid-element
    const manualOptionGridContainer = document.createElement("div");
    manualOptionGridContainer.className = "manual-options-grid";
    
    options[groupName].tastes?.forEach((option) => {
      const optionElement = document.createElement("label");
      optionElement.className = "manual-option-item";
        
      optionElement.dataset.value = JSON.stringify(option);

      // Unique ID for checkbox (optional but good practice)
      const inputId = `checkbox-${option.taste.toLowerCase().replace(/\s+/g, "-")}`;


      optionElement.innerHTML = `
        <input type="checkbox" id="${inputId}" class="taste-checkbox" />
        <div class="text-content">
          <strong>${option.taste} - ${option.description}</strong>
        </div>
      `;

      const checkbox = optionElement.querySelector("input");


      checkbox.addEventListener("click", (e) => {
        e.stopPropagation();
        
        optionElement.classList.toggle("selected");


        if (optionElement.classList.contains("selected")) {
          optionElement.dataset.clickedAt = Date.now();
        } else {
          delete optionElement.dataset.clickedAt;
        }
        
        updateSelectedPreferences();
      });
        
        
      optionElement.addEventListener("click", (event) => {
        // to stop event bubbling 
        event.stopPropagation();
      });

      manualOptionGridContainer.appendChild(optionElement);
      
    });

    manualOptionChildWrapper.appendChild(manualOptionGridContainer);
    manualOptionsWrapper.appendChild(manualOptionChildWrapper);
  });
};

function updateSelectedPreferences() {
  const selectedPrefs = document.getElementById("selectedTaste");
  const groupName = document.getElementById("groupName");
  const selectionType = document.getElementById("selectionType");
  selectionType.value = "true";

  const selectedOptions = Array.from(
    document.querySelectorAll(".manual-option-item.selected")
  ).sort((a,b) => a.dataset.clickedAt - b.dataset.clickedAt).map((el) => JSON.parse(el.dataset.value));


  const updatedPrefs = JSON.parse(selectedPrefs.value);
  /**
   * reset-all the existing group for empty tastes field
   */
  Object.keys(updatedPrefs).map((groupName)=>{

    updatedPrefs[groupName] = {
      ...updatedPrefs[groupName],
      tastes:[]
    };
  });





  
  selectedOptions.forEach((selectedOpt)=>{
    if(updatedPrefs[selectedOpt.groupName]){
      const isTasteExist = updatedPrefs[selectedOpt.groupName].tastes.find(tEle=>tEle.taste === selectedOpt.taste);
      if(!isTasteExist){
        updatedPrefs[selectedOpt.groupName].tastes = [...updatedPrefs[selectedOpt.groupName].tastes,{"taste":selectedOpt.taste}];
      }
    }else{
      updatedPrefs[selectedOpt.groupName] = {
        "tastes":[{"taste":selectedOpt.taste}],
        "currentIndex":"0"
      }
    }
  });

  selectedPrefs.value = JSON.stringify(updatedPrefs);

  const grpName = Object.keys(updatedPrefs).find((key)=>updatedPrefs[key]?.tastes?.length);
  /**
   * if any group found with non-empty tastes field then add that group as default groupName else leave it, as it is.
   */
  if(grpName){
    groupName.value = grpName;
  }
}


function hideSellingPlanOption(labelTexts, exact = false) {
  if(!Array.isArray(labelTexts)) return;

  let frequencyList = labelTexts;

  if(frequencyList.length == 0){
    const el = document.getElementById("frequency_list");
    try {
      const parsed = JSON.parse(el.dataset.options);
      if (Array.isArray(parsed)) {
        frequencyList = parsed;
      }
    } catch (err) {
      console.error("Failed to parse frequency_list:", err);
    }
  }

  const wrappers = document.querySelectorAll(
    ".appstleRadioSellingPlanWrapper .appstle-radio-wrapper"
  );

  const billingFieldset = [...document.querySelectorAll('fieldset.product-form__input--pill')]
    .find(fs => fs.querySelector('legend')?.textContent.trim() === 'Billing Frequency');

  const selected = billingFieldset.querySelector('input[type="radio"]:checked');
  const isPrepaid = selected && selected.value !== 'Pay per shipment';



  wrappers.forEach((wrapper) => {
    const label = wrapper.querySelector(".sellingplan");
    if (!label) return;

    const text = label.textContent.trim();
    const isMatch = exact
      ? frequencyList.some((lt)=>lt.toLowerCase() === text.toLowerCase())
      : frequencyList.includes(text.toLowerCase());

    if (isMatch && isPrepaid) {
      wrapper.style.display = "none";
    }
  });
}